import {
  Search,
  Star,
  CalendarDays,
  Scale,
  FileText,
  LineChart,
} from "lucide-react";
import { useT } from "@/lib/translation";
import {
  SidebarNav,
  type SidebarNavItem,
} from "@/components/shared/SidebarNav";

// Nav items keep translation keys, resolved with t() at render time.
type ResearchNavItem = Omit<SidebarNavItem, "label"> & {
  labelKey:
    | "nav:items.stockAnalysis"
    | "nav:items.watchlistsNav"
    | "nav:items.earningsCalendarNav"
    | "nav:items.transcripts"
    | "nav:items.dcfCalculators"
    | "nav:items.charts";
};

// Every item is always visible, including on the free tier. The paid ones are gated on
// their own page with a blur and CTA, not hidden from the sidebar.
const navItems: ResearchNavItem[] = [
  {
    to: "/analysis/stock-analysis",
    icon: Search,
    labelKey: "nav:items.stockAnalysis",
    isActive: (pathname) => pathname.startsWith("/analysis/stock-analysis"),
  },
  {
    to: "/analysis/watchlist",
    icon: Star,
    labelKey: "nav:items.watchlistsNav",
  },
  {
    to: "/analysis/earnings-calendar",
    icon: CalendarDays,
    labelKey: "nav:items.earningsCalendarNav",
  },
  {
    to: "/analysis/transcripts",
    icon: FileText,
    labelKey: "nav:items.transcripts",
  },
  {
    to: "/analysis/reverse-dcf",
    icon: Scale,
    labelKey: "nav:items.dcfCalculators",
  },
  {
    to: "/analysis/charts",
    icon: LineChart,
    labelKey: "nav:items.charts",
  },
];

export const ResearchNavigation = () => {
  const t = useT();
  const items: SidebarNavItem[] = navItems.map(({ labelKey, ...item }) => ({
    ...item,
    label: t(labelKey),
  }));
  return <SidebarNav navItems={items} roadmapPath="/analysis/roadmap" />;
};
